import profileApi from "./profileApi";
import { mainPhotoCropNormal } from "utils/helpers/cropPhoto";
import { commonErrorResponses, Dispatch } from "redux/commonTypes";
import { actionTypes, extendedProfileInfoType, genderEnumFromApi, profileDataType, profileProps } from "./profileTypes";
import { ageFormatter } from "utils/helpers";

import bonusActions from "redux/ducks/bonus/bonusActions";
import purchaseActions from "redux/ducks/purchase/purchaseActions";
import authActions from "redux/ducks/auth/authActions";
import messagesActions from "redux/ducks/messages/messagesActions";
import viewsActions from "redux/ducks/views/viewsActions";
import { setSnippetsMap } from "../messages/messagesMaps";
import { photoType } from "../users/usersTypes";
import { galleryTypes } from "../photos/photosTypes";
import pinnedActions from "../pinned/pinnedActions";
import { fillGiftPreview } from "pages/Profile/components/Bounty/utils/fillGiftPreview";
import { FLAG, setFlag, removeFlag, getFlag } from "utils/verificationFlags";


const Actions = {
  setProifle: (userData: profileDataType) => ({
    type: actionTypes.SET_ME,
    payload: {
      idProfile: userData!.profile!.id,
      //@ts-ignore
      gender: genderEnumFromApi[userData!.profile!.sex],
      name: userData!.profile!.name,
      birthday: `${userData!.profile!.birthday[8]}${userData!.profile!.birthday[9]}.${userData!.profile!.birthday[5]}${userData!.profile!.birthday[6]}.${userData!.profile!.birthday[0]}${userData!.profile!.birthday[1]}${userData!.profile!.birthday[2]}${userData!.profile!.birthday[3]}`, 
      phone: userData!.profile!.phone,
      city: userData!.profile!.city!.name,
      age: ageFormatter(userData!.profile!.birthday),
      avatar: (() => {
        const pub = (userData!.photos || []).filter((el) => el?.photoInfo?.galleryType === galleryTypes.Public);
        // Аватар: главное фото, иначе — первое публичное (даже немодерированное,
        // как в приле: единственное фото становится аватаром без плашки).
        const main = pub.filter((el) => el?.photoInfo?.mainPhoto === true)[0];
        const pick = main || pub[0];
        return (pick?.photoUrl?.photoCropNormal || pick?.photoUrl?.photoNormal || "");
      })(),
      publicPhotos: (userData!.photos || []).filter(
        (el) => el?.photoInfo?.galleryType === galleryTypes.Public
      ),
      privatePhotos: (userData!.photos || []).filter(
        (el) => el?.photoInfo?.galleryType === galleryTypes.Private
      ),
      interests:
        Array.isArray(userData!.profile!.interest) &&
        userData!.profile!.interest.map((el) => el.id) || [],
      languages:
        Array.isArray(userData!.profile!.languages) &&
        userData!.profile!.languages.map((el) => el.id) || [],
      interestsString:
        Array.isArray(userData!.profile!.interest) &&
        userData!.profile!.interest.map((el) => el.name).join(", "),
      languagesString:
        Array.isArray(userData!.profile!.languages) &&
        userData!.profile!.languages.map((el) => el.name).join(", "),
      smoking: userData!.profile!.badHabits?.smoking,
      alcohol: userData!.profile!.badHabits?.alcohol,
      income: userData!.profile!.income,
      occupation: userData!.profile!.occupation,
      education: userData!.profile!.education,
      hair: userData!.profile!.appearance?.hair,
      eyes: userData!.profile!.appearance?.eyes,
      height: userData!.profile!.appearance?.height,
      weight: userData!.profile!.appearance?.weight,
      country: userData!.profile!.country!.name,
      cityId: userData!.profile!.city!.id,
      countryId: userData!.profile!.country!.id,
      aboutMe: userData!.profile!.aboutMe,
      citizenship: userData!.profile!.citizenship?.name,
      citizenshipId: userData!.profile!.citizenship?.id,
      datingPurpose: userData!.profile!.datingPurpose,
      variabilityBirthday: userData!.profile?.variabilityBirthday,
      variabilityName: userData!.profile?.variabilityName,
      relation: userData!.profile?.relation,
      sexTypes: Array.isArray(userData!.profile!.sexPreference?.sexTypes) &&
      userData!.profile!.sexPreference?.sexTypes.map((el) => el.id) || [], 
      breast: userData.profile.appearance?.breast,
      sexualOrientation: userData.profile.sexPreference?.sexualOrientation,
      periodicity: userData.profile.sexPreference?.periodicity,
      sexTypesString:
      Array.isArray(userData!.profile!.sexPreference?.sexTypes) &&
      userData!.profile!.sexPreference?.sexTypes.map((el) => el.name).join(", "),
      children: userData.profile.children===true?0:userData.profile.children===false?1:null,
      idFb: userData.profile.idFacebook,
      idGoogle: userData.profile.idGoogle,
      isNeedFill: userData.isAnonymousProfile
    },
  }),
  setAnonymousMe: (status: boolean) => {
    return {
      type: actionTypes.SET_ANONYMOUS_ME,
      payload: status
    }
  },
  setProifleExtended: (userData: extendedProfileInfoType, sex: 0 | 1 | 2) => ({
    type: actionTypes.SET_PROFILE_EXTENDED,
    payload: {
      idProfile: userData!.id,
      //@ts-ignore
      gender: genderEnumFromApi[sex],
      name: userData!.name,
      birthday: `${userData!.birthday[8]}${userData!.birthday[9]}.${userData!.birthday[5]}${userData!.birthday[6]}.${userData!.birthday[0]}${userData!.birthday[1]}${userData.birthday[2]}${userData!.birthday[3]}`, 
      city: userData!.city?.name,
      age: ageFormatter(userData!.birthday),
      country: userData!.country?.name,
      cityId: userData!.city?.id,
      countryId: userData!.country?.id,
    },
  }),
  setAvatar: (avatarUrl: string, avatarForPinned: string) => ({
    type: actionTypes.SET_AVATAR,
    payload: {avatarUrl, avatarForPinned},
  }),
  setBirthDate: (date: string) => ({
    type: actionTypes.SET_BIRTH_DATE,
    payload: date,
  }),
  setName: (name: string) => ({
    type: actionTypes.SET_NAME,
    payload: name,
  }),
  setCity: (cityId: number) => ({
    type: actionTypes.SET_CITY,
    payload: cityId,
  }),
  setCountry: (countryId: number) => ({
    type: actionTypes.SET_COUNTRY,
    payload: countryId,
  }),
  setGender: (gender: string) => ({
    type: actionTypes.SET_GENDER,
    payload: gender,
  }),
  setInterestedGender: (interestedGender: string) => ({
    type: actionTypes.SET_INTERESTED_GENDER,
    payload: interestedGender,
  }),
  setEmail: (email: string | null) => ({
    type: actionTypes.SET_EMAIL,
    payload: email,
  }),
  resetAll: () => ({
    type: actionTypes.RESET_ALL_PROFILE,
  }),
  setEditSuccess: (status: boolean) => ({
    type: actionTypes.SET_EDIT_SUCCESS,
    payload: status,
  }),
  setProfileLoading: (status: boolean) => ({
    type: actionTypes.SET_PROFILE_LOADING,
    payload: status,
  }),
  setPhotos: (photos: Array<photoType>, type: galleryTypes) => ({
    type: (type === galleryTypes.Public ? actionTypes.SET_PUBLIC_PHOTOS : actionTypes.SET_PRIVATE_PHOTOS),
    payload: photos,
  }),
  setVariabilityBirthday: (value: boolean) => ({
    type: actionTypes.SET_VARIABILITY_BIRTHDAY,
    payload: value
  }),
  setVariabilityName: (value: boolean) => ({
    type: actionTypes.SET_VARIABILITY_NAME,
    payload: value
  }),
  getProfileInfo: () => (dispatch: Dispatch, getState?: () => any) => {
    // dispatch(Actions.setProfileLoading(true));
    profileApi.fetchMe().then((resp) => {
      if (resp.status === 200) {

        // Гейт модерации фото 1в1 с приложением (core/profile/sagas):
        // отклонено = главное публичное фото с verified===1, ЛИБО есть
        // lastPhotoRejection и нет годного публичного фото.
        try {
          const photosArr: any[] = Array.isArray((resp.data as any).photos) ? (resp.data as any).photos : [];
          const isRealUri = (u?: string) => !!u && u.indexOf("empty_main_photo") < 0;
          const pickUrl = (o: any) => [o?.photoNormal, o?.photoLarge, o?.photoCropNormal, o?.photoSmall].find(isRealUri) || null;
          const mainRejected = photosArr.some((ph) => ph?.photoInfo?.mainPhoto
            && ph?.photoInfo?.galleryType !== 1
            && ph?.photoInfo?.verified === 1);
          const lastPhotoRejection = (resp.data as any).lastPhotoRejection || null;
          const reason = (lastPhotoRejection && lastPhotoRejection.reason !== undefined && lastPhotoRejection.reason !== null)
            ? lastPhotoRejection.reason : null;
          const hasUsablePublicPhoto = photosArr.some((ph) => ph?.photoInfo
            && ph.photoInfo.galleryType !== 1
            && ph.photoInfo.verified !== 1
            && isRealUri(pickUrl(ph?.photoUrl)));
          const rejected = mainRejected || (!!lastPhotoRejection && !hasUsablePublicPhoto);
          const byNewest = (a: any, b: any) => new Date(b?.photoInfo?.dateCreate || 0).getTime() - new Date(a?.photoInfo?.dateCreate || 0).getTime();
          const real = photosArr.filter((ph) => isRealUri(pickUrl(ph?.photoUrl))).sort(byNewest);
          // Какое фото показать на экране отказа. Сначала публичные (обычные
          // приватные фото на этот экран не тянем), среди них — отклонённое
          // (verified === 1). Отклонённое бэк может перекинуть в приватную
          // галерею (как пишет приложение) — тогда, если публичного нет,
          // берём самое свежее отклонённое приватное.
          const publicReal = real.filter((ph) => ph?.photoInfo?.galleryType !== 1);
          const shown = publicReal.find((ph) => ph?.photoInfo?.verified === 1)
            || publicReal[0]
            || real.find((ph) => ph?.photoInfo?.galleryType === 1 && ph?.photoInfo?.verified === 1)
            || null;
          const uri = pickUrl(shown?.photoUrl) || null;
          dispatch(Actions.setPhotoRejected({ rejected, reason: rejected ? reason : null, uri: rejected ? uri : null }));
          // Липкий флаг (переживает перезагрузку). Снимаем, только если и
          // extended-профиль (mainPhotoVerifiedStatus) уже не считает отказом.
          const st = getState ? getState().profileReducer : null;
          if (rejected || (st && st.mainPhotoRejected)) {
            setFlag(FLAG.photoRejected, "1");
          } else if (!st || st.gestureVerifyStatus !== null) {
            removeFlag(FLAG.photoRejected);
          }
        } catch (e) {
          dispatch(Actions.setPhotoRejected({ rejected: false, reason: null, uri: null }));
        }
        dispatch(bonusActions.setBonusPercent(resp.data.percentFillProfile))
        dispatch(Actions.setProifle(resp.data));
        window.localStorage.idProfile = resp.data.profile.id;

        dispatch(Actions.setProfileLoading(false));
        dispatch(Actions.setAnonymousMe(resp.data.isAnonymousProfile));
      } 
    })
    .catch(err => {
      if (err.response?.status == 401) {
        dispatch(authActions.setNeedRefresh(true))
      }
  })
  },
  editProfile: (data: profileProps) => (dispatch: Dispatch) => {
    data.birthday && dispatch(Actions.setVariabilityBirthday(false));
    profileApi.editProfile(data).then((resp) => {
      dispatch(bonusActions.setBonusPercent(resp.data.percentFillProfile));
      dispatch(Actions.setEditSuccess(true));

      setTimeout(() => {
        dispatch(Actions.setEditSuccess(false));
      }, 3000)
    }).catch(err => {
      if (err.response?.status === 401) {
        dispatch(authActions.setNeedRefresh(true));
      }
    })
  },
  getProfileBalance: () => (dispatch: Dispatch) => {
    dispatch(messagesActions.setSnippetLoading(true));
    dispatch(pinnedActions.setLoadingPinned(true));

    profileApi
      .getProfileBalance()
      .then((response) => {
        if (response.status === 200) {
          const ent = response.data;
          dispatch(purchaseActions.setBoosts(ent.boosts ?? 0));
          dispatch(purchaseActions.setSomePremiums({
            hiddenRest: ent.invisibleDeadline || null,
            onlineRest: ent.active ? (ent.expiresAt || null) : null,
            pinnedRest: ent.pinnedDeadline || null,
            premiumRest: ent.active ? (ent.expiresAt || null) : null,
          }));
        }
      })
      .finally(() => {
        dispatch(messagesActions.setSnippetLoading(false))
        dispatch(pinnedActions.setLoadingPinned(false));
      });
  },
  // silent: фоновая перепроверка (опрос статуса модерации) — без скелетонов,
  // иначе сайдбар-сообщения и пины мигали каждые 20 с и при фокусе окна.
  getExtendedProfileInfo: (silent: boolean = false) => (dispatch: Dispatch, getState?: () => any) => {
    if (!silent) {
      dispatch(messagesActions.setSnippetLoading(true));
      dispatch(pinnedActions.setLoadingPinned(true));
    }

    profileApi.getExtendedProfileInfo()
      .then((resp) => {
        if (resp.status !== 200) {
          return null;
        }

        window.localStorage.idProfile = resp.data.previewProfile.previewUserInfo.id;

        dispatch(viewsActions.setViewsNewCounter(resp.data.countVisitors));
        const claimed = !!resp.data.fillProfileGiftClaimed;
        dispatch(bonusActions.setBonusUsed(claimed));
        const gender = genderEnumFromApi[resp.data.profileSex] || "Female";
        dispatch(Actions.setProifleExtended(resp.data.previewProfile.previewUserInfo, resp.data.profileSex));
        // Карточка пина — кадрированное фото, как user-preview-pinned-card в RN.
        dispatch(Actions.setAvatar(resp.data.previewProfile.mainPhoto.photoCropNormal, mainPhotoCropNormal(resp.data.previewProfile.mainPhoto)));

        if (resp.data.previewChats) {
          dispatch(messagesActions.setSnippets(setSnippetsMap(resp.data.previewChats.slice(0, 3))));
        }

        dispatch(messagesActions.setCounter(resp.data.countUnreadMessages));
        dispatch(Actions.setAnonymousMe(resp.data.previewProfile.isAnonymousUser));
        // Статус жест-верификации (как в приложении: previewProfile.gestureVerificationStatus).
        // 0 — пройдена, 1 — ОТКАЗ (во время модерации бэк отдаёт 2, поэтому 1
        // однозначно отказ, без клиентского «грейса»), 2 — на проверке,
        // 3/нет — не отправлена.
        // pending читаем ДО диспатча статуса (как в приле — без гонки).
        const verificationPending = getFlag(FLAG.verificationPending) === "1";
        const rawGvs = resp.data.previewProfile.gestureVerificationStatus;
        const gvs = typeof rawGvs === "number" ? rawGvs : 3;
        dispatch(Actions.setGestureVerifyStatus(gvs));
        if (gvs === 1) {
          // Отказ подтверждён статусом: липкий флаг отказа, снимаем «ожидается».
          // Экран отказа показывает гейт в App.tsx.
          setFlag(FLAG.verificationRejected, "1");
          removeFlag(FLAG.verificationPending);
        } else if (gvs === 0) {
          // Одобрено — снимаем анти-скам гейт на чаты.
          removeFlag(FLAG.verificationRejected);
          dispatch(Actions.setNotVerified(false));
          // Только что одобрили (ждали проверку) — модалка «профиль
          // верифицирован» ОДИН раз, флаг снимаем.
          if (verificationPending) {
            removeFlag(FLAG.verificationPending);
            dispatch(Actions.setVerifiedSuccessModal(true));
          }
        } else if (gvs === 2) {
          // Повторно отправили, идёт проверка — старый отказ неактуален.
          removeFlag(FLAG.verificationRejected);
        }

        // Главное фото отклонено на модерации (mainPhotoVerifiedStatus === 1).
        // Статус 1 — это и «реально отклонено», и «фото просто нет» (плейсхолдер
        // empty_main_photo), поэтому отказом считаем ТОЛЬКО при настоящем фото.
        // И не перебиваем отказ жеста (gvs === 1 — приоритет у него).
        const mp: any = resp.data.previewProfile.mainPhoto || {};
        const mainPhotoUrl = mp.photoNormal || mp.photoCropNormal || mp.photoSmall || "";
        const hasRealMainPhoto = !!mainPhotoUrl && mainPhotoUrl.indexOf("empty_main_photo") < 0;
        const mainPhotoRejected = hasRealMainPhoto
          && gvs !== 1
          && resp.data.previewProfile.mainPhotoVerifiedStatus === 1;
        dispatch(Actions.setMainPhotoRejected(mainPhotoRejected));
        // Нет настоящего главного фото (плейсхолдер empty_main_photo) — гейт
        // «загрузи фото», даже если бэк не вернул ошибку notHavePhoto.
        dispatch(Actions.setNotHavePhoto(!hasRealMainPhoto));
        const st = getState ? getState().profileReducer : null;
        if (mainPhotoRejected || (st && st.photoRejected)) {
          setFlag(FLAG.photoRejected, "1");
        } else if (!st || !st.profileLoading) {
          removeFlag(FLAG.photoRejected);
        }

        // Entitlement needed for gift preview (Male: hide Basic if active plan).
        return profileApi.getProfileBalance().then((entResp) => {
          const ent = entResp.data || {};
          const active = !!ent.active;
          dispatch(purchaseActions.setBoosts(ent.boosts ?? 0));
          dispatch(purchaseActions.setSomePremiums({
            hiddenRest: ent.invisibleDeadline || null,
            onlineRest: active ? (ent.expiresAt || null) : null,
            pinnedRest: ent.pinnedDeadline || null,
            premiumRest: active ? (ent.expiresAt || null) : null,
            place: resp.data.profilePlaceInSearch,
          }));
          dispatch(bonusActions.setBonusData(claimed ? [] : fillGiftPreview(gender, active)));
        }).catch(() => {
          dispatch(bonusActions.setBonusData(claimed ? [] : fillGiftPreview(gender, false)));
          dispatch(purchaseActions.setSomePremiums({
            hiddenRest: null,
            onlineRest: null,
            pinnedRest: null,
            premiumRest: null,
            place: resp.data.profilePlaceInSearch,
          }));
        });
      })
      .catch(err => {
        if (err.response?.data?.errorCode === commonErrorResponses.notVerified) {
          dispatch(Actions.setNotVerified(true));
          dispatch(Actions.setGender(genderEnumFromApi[err.response.data.sex] || "Female"));
        }
        if (err.response?.data?.errorCode === commonErrorResponses.notHavePhoto) {
          dispatch(Actions.setNotHavePhoto(true));
          dispatch(Actions.setGender(genderEnumFromApi[err.response.data.sex] || "Female"));
        }
        if (err.response?.data?.errorCode === commonErrorResponses.photoWasDeleted) {
          dispatch(Actions.setNotHavePhoto(true));
          dispatch(Actions.setReasonDeletingPhoto(err.response.data.reason))
          dispatch(Actions.setGender(genderEnumFromApi[err.response.data.sex] || "Female"));
        }
        if (err.response?.data?.errorCode === commonErrorResponses.verifyWasDeleted) {
          dispatch(Actions.setNotVerified(true));
          dispatch(Actions.setGender(genderEnumFromApi[err.response.data.sex] || "Female"));
        }
      })
      .finally(() => {
        if (!silent) {
          dispatch(messagesActions.setSnippetLoading(false));
          dispatch(pinnedActions.setLoadingPinned(false));
        }
      });
  },
  setNotVerified: (status: boolean) => ({
    type: actionTypes.SET_NOT_VERIFIED,
    payload: status
  }),
  setGestureVerifyStatus: (status: number | null) => ({
    type: actionTypes.SET_GESTURE_VERIFY_STATUS,
    payload: status
  }),
  setPhotoRejected: (payload: { rejected: boolean; reason: number | null; uri: string | null }) => ({
    type: actionTypes.SET_PHOTO_REJECTED,
    payload
  }),
  setMainPhotoRejected: (status: boolean) => ({
    type: actionTypes.SET_MAIN_PHOTO_REJECTED,
    payload: status
  }),
  setVerifiedSuccessModal: (status: boolean) => ({
    type: actionTypes.SET_VERIFIED_SUCCESS_MODAL,
    payload: status
  }),
  setFemaleVerifyModal: (mode: null | "verify" | "pending") => ({
    type: actionTypes.SET_FEMALE_VERIFY_MODAL,
    payload: mode
  }),
  // Анти-скам гейт (≈3-й чат) 1в1 с приложением (showVerificationRequiredAlert /
  // showFemaleVerificationModal): если селфи уже на проверке (статус 2 или
  // pending-флаг) — попап «Фото на проверке, дождитесь», БЕЗ повторной
  // верификации; иначе — попап «Подтвердите профиль» с кнопкой верификации.
  requireVerification: () => (dispatch: Dispatch, getState?: () => any) => {
    const st = getState ? getState().profileReducer : {};
    const status = st.gestureVerifyStatus;
    if (status === 0) {
      return;
    }
    if (status === 1) {
      // Отказ — им занимается гейт отказа (незакрываемый экран).
      return;
    }
    const pending = status === 2 || getFlag(FLAG.verificationPending) === "1";
    dispatch(Actions.setFemaleVerifyModal(pending ? "pending" : "verify"));
  },
  // Проверка перед открытием НОВОГО чата (как openChatByUserId с
  // checkFemaleVerification в приле). Резолвится true — можно открывать чат.
  checkCanOpenChat: () => (dispatch: Dispatch, getState?: () => any): Promise<boolean> => {
    const st = getState ? getState().profileReducer : {};
    if (st.gender !== "Female" || st.gestureVerifyStatus === 0) {
      return Promise.resolve(true);
    }
    const needs = (d: any) => !!d && (d.showVerification || d.needVerification || d.requiresVerification
      || d.errorCode === commonErrorResponses.notVerified || d.code === commonErrorResponses.notVerified);
    return profileApi.antiScamCheck().then((resp) => {
      if (needs(resp.data)) {
        dispatch(Actions.requireVerification() as any);
        return false;
      }
      return true;
    }).catch((err) => {
      if (needs(err?.response?.data)) {
        dispatch(Actions.requireVerification() as any);
        return false;
      }
      // Сбой проверки не должен блокировать чат — сервер всё равно не даст
      // отправить сообщение без верификации (ошибка 119 → тот же попап).
      return true;
    });
  },
  // «Нет главного фото» — в ленту не пускаем. Флаг переживает перезагрузку
  // (localStorage.needsMainPhoto): раньше после обновления страницы на экране
  // загрузки фото флаг терялся и /auth/* сразу редиректил в поиск.
  setNotHavePhoto: (status: boolean) => {
    try {
      status
        ? window.localStorage.setItem("needsMainPhoto", "1")
        : window.localStorage.removeItem("needsMainPhoto");
    } catch (e) { /* noop */ }
    return {
      type: actionTypes.SET_NOT_HAVE_PHOTO,
      payload: status
    };
  },
  getOnlyPhotos: () => (dispatch: Dispatch) => {
    profileApi.fetchMe().then((resp) => {
      dispatch(Actions.setPhotos(resp.data.photos.filter(
        (el: photoType) => el.photoInfo!.galleryType === galleryTypes.Public
      ), galleryTypes.Public));
      dispatch(Actions.setPhotos(resp.data.photos.filter(
        (el: photoType) => el.photoInfo!.galleryType === galleryTypes.Private
      ), galleryTypes.Private));
    })
  },
  linkFb: (token: string) => (dispatch: Dispatch) => {
    profileApi.fbLink(token).then(() => dispatch(Actions.setFbId("1"))).catch(err => {
      if (err.response?.data?.errorCode == commonErrorResponses.fbAlreadyLinked) {
        dispatch(Actions.setLinkSocialError("Данный аккаунт уже привязан"))
      }
    })
  },
  linkGoogle: (token: string) => (dispatch: Dispatch) => {
    profileApi.googleLink(token).then(() => dispatch(Actions.setGoogleId("1"))).catch(err => {
      if (err.response?.data?.errorCode == commonErrorResponses.googleAlreadyLinked) {
        dispatch(Actions.setLinkSocialError("Данный аккаунт уже привязан"))
      }
    })
  },
  unlinkFb: () => (dispatch: Dispatch) => {
    profileApi.fbUnlink().then(() => dispatch(Actions.setFbId(""))).catch(err => {
      if (err.response?.data?.errorCode == commonErrorResponses.lastAuthMethod) {
        dispatch(Actions.setLinkSocialError("Вы не можете отвязать единственный привязанный сервис"))
      }
    })
  },
  unlinkGoogle: () => (dispatch: Dispatch) => {
    profileApi.googleUnlink().then(() => dispatch(Actions.setGoogleId(""))).catch(err => {
      if (err.response?.data?.errorCode == commonErrorResponses.lastAuthMethod) {
        dispatch(Actions.setLinkSocialError("Вы не можете отвязать единственный привязанный сервис"))
      }
    })
  },
  setFbId: (id: string) => ({
    type: actionTypes.SET_FB_ID,
    payload: id
  }),
  setGoogleId: (id: string) => ({
    type: actionTypes.SET_GOOGLE_ID,
    payload: id
  }),
  setLinkSocialError: (status: string) => ({
    type: actionTypes.SET_LINK_SOCIALS_ERR,
    payload: status
  }),
  setReasonDeletingPhoto: (reason: string) => ({
    type: actionTypes.SET_REASON_DELETING_PHOTO,
    payload: reason
  }),
  setPrevRoute: (route: string) => {
    return {
      type: actionTypes.SET_PREV_ROUTE,
      payload: route
    }
  },
};

export default Actions;
